/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OrderInputs */

const en_order = /** @type {(inputs: OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const es_order = /** @type {(inputs: OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {OrderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const order = /** @type {((inputs?: OrderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OrderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order(inputs)
	return es_order(inputs)
});